module.exports = __webpack_public_path__ + "img/osakana_logo.d74b965f.png";